import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { ISelectProps } from './types';

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '~ .MuiAutocomplete-popper': {
    '& .MuiPaper-root': {
      border: '2px solid ' + theme.colors.grass,
      borderRadius: '0.5rem',
    },
  },
  '.MuiInputBase-input': {
    '&::placeholder': {
      color: theme.colors.grey,
      opacity: 1,
    },
  },
}));

export const Select: React.FC<ISelectProps | any> = ({ renderInput, ...props }) => {
  return <StyledAutocomplete {...props} renderInput={renderInput} />;
};
